import React from "react";
import Modal from "../../../../components/Common/Modal/Modal";
import CreateNewRole from "./CreateNewRole";

const CreateNewRoleModal = ({
  addRoleModal,
  setaddRoleModal,
  handleSearchQuery,
}) => {
  return (
    <Modal
      isOpen={addRoleModal}
      heading={"Add New Role"}
      toggle={() => {
        setaddRoleModal(false);
      }}
      width={"50"}
    >
      <CreateNewRole
        handleSearchQuery={handleSearchQuery}
        setaddRoleModal={setaddRoleModal}
      />
    </Modal>
  );
};

export default CreateNewRoleModal;
